<template>
    <div>
        <v-container max-width="2100">
            <v-card class="mx-auto my-5" max-width="2100">
                <v-system-bar class="py-5 px-3" color="#1973a5" style="color: #fff" dark>
                    Nuevos ingresos
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 px-3 elevation-1" max-width="2100">
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchDistrito" label="Distrito"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchClinica" label="Clínica"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line></v-text-field>
                    </v-col>
                    <v-btn color="green" dark @click="exportToExcel">
                        Exportar
                    </v-btn>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" max-width="2100">
                <div style="max-height: 70vh; overflow-y: scroll">
                    <v-data-table :headers="headers" :items="indexedData" class="elevation-1 py-5"
                        :search="searchDistrito" :sort-by.sync="sortBy" :loading="isLoading"
                        loading-text="Cargando... Por favor espere">
                    </v-data-table>
                </div>
            </v-card>
        </v-container>
        <!-- <v-dialog v-model="dialog" max-width="600px" persistent>
            <LiberarCupo @closeDialog="closeDialog" />
        </v-dialog> -->
    </div>
</template>
<style>
.bg-primary-table {
    font-weight: 460;
}

table {
    font-size: .9rem;
}

.bordeado {
    border: 1px solid #0000004a;
    border-radius: 0.3rem;
    padding: 0.3rem;
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 2.1rem;
}

.justify-content-end {
    justify-content: end;
}

.container {
    max-width: 3000px !important;
}
</style>
<script>
import axios from "axios";
/* import * as XLSX from 'xlsx'; */
/* import XLSX from 'xlsx'; */
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
/* import LiberarCupo from "../../../../mov-paciente-admin/liberar_cupo.vue"; */
export default {
    data() {
        return {
            dialog: false,
            valor1: 15,
            valor2: 10,
            ver: false,
            dataReporte: [],
            search: "",
            centroContratado: "",
            nutricionista: "",
            dataEnvio: {
                fecha: null,
                usuario: null,
                descripCas: null
            },
            date: new Date(
                Date.now() - 2592000000 - new Date().getTimezoneOffset() * 60000
            )
                .toISOString()
                .substr(0, 10),
            searchDistrito: "",
            searchClinica: "",
            isLoading: false,
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "N°", value: "index" },
                { text: "Fecha Reg", value: "fecha_reg" },
                {
                    text: "N° Doc",
                    align: "start",
                    value: "num_doc",
                },
                { text: "Paciente", value: "paciente" },
                { text: "Tipo seguro", value: "tipo_seguro" },
                { text: "Dirección", value: "direccion" },
                { text: "Distrito", value: "distrito", align: "center" },
                { text: "Hospital", value: "hospital", align: "center" },
                { text: "Serología", value: "serologia", align: "center" },
                { text: "Tipo paciente", value: "tipo_paciente", align: "center" },
                { text: "Motivo", value: "motivo_liberacion", align: "center" },
                { text: "Ref. recibida", value: "ref_recibida", align: "center" },
                { text: "Ref. enviada", value: "ref_enviada", align: "center" },
                { text: "Clínica", value: "descripCas", align: "center" }
            ],
            fechaReporte: "",
            mesReporte: "",
            idCas: null
        };
    },
    methods: {
        exportToExcel() {
            // Datos que deseas exportar
            const XLSXStyle = require("xlsx-js-style");

            // Definir cabecera
            const headers = [
                "N°", "FECHA DE REG", "N° DOC", "PACIENTE",
                "TIPO SEGURO", "DIRECCIÓN", "DISTRITO", "TELÉFONO",
                "HOSPITAL", "SEROLOGÍA", "TIPO PACIENTE", "MOTIVO LIBERACIÓN", "REF. RECIBIDA", "REF. ENVIADA", "CLÍNICA", "FRECUENCIA", "TURNO", "DISTRITO", "OBSERVACIÓN"
            ];
            // Convertir datos a formato adecuado para la hoja de cálculo
            const datos = this.filteredData;
            // Inicializar rows fuera del bucle
            let contador = 1;
            const rows = datos.map((item, index) => [
                index + 1, item.fecha_reg, item.num_doc, item.paciente,
                item.tipo_seguro, item.direccion, item.distrito, item.telefono,
                item.hospital, item.serologia, item.tipo_paciente, item.motivo_liberacion, item.ref_recibida, item.ref_enviada, item.descripCas, item.frecuencia, item.turno, item.distrito_cas, item.observacion
            ]);

            // Combinar cabecera y datos
            const worksheetData = [headers, ...rows];

            // Crear una hoja de cálculo
            const worksheet = XLSXStyle.utils.aoa_to_sheet(worksheetData);
            const workbook = XLSXStyle.utils.book_new();
            XLSXStyle.utils.book_append_sheet(workbook, worksheet, 'Nuevos - Reingresos');

            // Exportar a archivo Excel
            XLSXStyle.writeFile(workbook, 'Nuevos_Reingresos.xlsx');
        },
        openDialog() {
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
            this.dataInit();
        },
        filtro() {
            const partesFecha = this.date.split('-');
            const año1 = partesFecha[0];
            const mes1 = partesFecha[1];
            const dia1 = partesFecha[2];
            this.fechaReporte = `${dia1}-${mes1}-${año1}`;
            this.dataEnvio.fecha = this.formatearFecha(this.date);
            this.dataInit();
            this.loadFecha(this.dataEnvio.fecha);
        },
        dataInit() {
            this.isLoading = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_reporte_nuevos_reingresos/", {}, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            console.log("exito", res);
                            this.isLoading = false;
                            this.dataReporte = res.data;
                        })
                        .catch((res) => {
                            this.isLoading = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.isLoading = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
    },
    mounted() { },
    computed: {
        filteredData() {
            if (!this.searchDistrito && !this.searchClinica) {
                return this.dataReporte;
            }

            let filtered = this.dataReporte;

            if (this.searchDistrito) {
                filtered = filtered.filter((item) =>
                    item.distrito_clinica
                        .toLowerCase()
                        .includes(this.searchDistrito.toLowerCase())
                );
            }

            if (this.searchClinica) {
                filtered = filtered.filter((item) =>
                    item.clinica.toLowerCase().includes(this.searchClinica.toLowerCase())
                );
            }

            return filtered;
        },

        headersWithIndex() {
            return [
                { text: "#", value: "index" }, // Encabezado para el índice
                ...this.headers, // Encabezados existentes
            ];
        },
        // Utiliza la matriz de datos con índices
        indexedData() {
            return this.filteredData.map((item, index) => ({
                ...item,
                index: index + 1,
            }));
        },
    },
    created() {
        this.centroContratado = sessionStorage.getItem("descripCas");
        this.dataEnvio.descripCas = sessionStorage.getItem("descripCas");
        this.nutricionista = sessionStorage.getItem("nombre");
        this.idCas = sessionStorage.getItem("urlCas");
        console.log(sessionStorage.getItem("usuario"));
        this.dataEnvio.usuario = sessionStorage.getItem("usuario");
        this.dataInit();
    },
    components: {
        /*     LiberarCupo */
    },
};
</script>